import request from '@/router/axios'

export function getPage(query) {
    return request({
        url: '/chain/driverfleetmember/memberList',
        method: 'get',
        params: query
    })
}

